import http from '../http';
import Qs from 'qs';
// 数据统计
const getCurrentSemesterStatistics = (params) =>
  http
    .get('/theUserIdentity/enrollStatistic/currentSemesterStatistics', {
      params
    })
    .then((res) => res.data);
// 应收情况
const getRevenueDataStatistic = (params) =>
  http
    .get('/theUserIdentity/enrollStatistic/getRevenueDataStatistic', { params })
    .then((res) => res.data);
// 待办提醒
const getToRemind = (params) =>
  http
    .get('/theUserIdentity/enrollStatistic/toRemind', { params })
    .then((res) => res.data);
// 课程订单列表
// const getOrderList = (params) =>
//   http
//     .get('/userOrder/theUserIdentity/courseOrderPage', { params })
//     .then((res) => res.data)
const getOrderList = (params) =>
  http
    .get('/theUserIdentity/UserOrder/courseOrderPage', { params })
    .then((res) => res.data);
// 订单退款
const orderRefund = (params) =>
  http
    .post('/userOrder/refund', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 课程订单详情(2022.07.22废弃)
const getCourseOrderDetail = (params) =>
  http.get('/userOrder/courseOrderDetail', { params }).then((res) => res.data);
// 获取学校列表 v1.3.1
const getSchoolsList = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);
// 获取校区列表(v1.3.1)
const getBranchList = (params) =>
  http.get('/sysSchools/listAll', { params }).then((res) => res.data);
// 年度学期列表
const getlistTerms = (params) =>
  http.get('/yearTerms/schoolTerms', { params }).then((res) => res.data);
// 获取学年列表（新）
const getDataSearchYearList = (params) =>
  http.get('/dataSearch/getYearList', { params }).then((res) => res.data);
// v1.3.1 查询班级树(新)
const getGradeAndClass = (params) =>
  http.get('/class/listClass', { params }).then((res) => res.data);
// 平台端 - 服务详情 学校统计 v1.3.1
const getOrgSchoolsNew = (params) =>
  http.get('/sysOrganizations/getRelSchool', { params }).then((res) => res.data);
// 修改预报名订单的缴费开始时间/缴费截止时间
const updatePreOrderPayTime = (params) =>
  http
    .post('/userOrder/updatePreOrderPayTime', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 获取学校列表  运营端,教育局
const getgoodSchoolList = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);

// 获取机构下面的学校
const getOrgSchoolListNew = (params) =>
  http
    .get('/schoolOrgRel/pageOrgSchoolName', { params })
    .then((res) => res.data);

// 获取运营订单列表
const getOperateOrderList = (params) =>
  http.get('/userOrder/sysOrderPage', { params }).then((res) => res.data);

// 运营端的 退款订单列表
const opeRefundOrder = (params) =>
  http
    .get('/userOrder/sysRefundOrderPage', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
    .then((res) => res.data);

// 运营端的 退款订单列表
const getRefundOrderListApi = (params) =>
  http
    .get('/theUserIdentity/UserOrder/refundOrderPage', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
    .then((res) => res.data);

// 查询可退费内容和退款记录
const getRefundDtl = (params) =>
  http.get('/userOrder/getRefundDtl', { params }).then((res) => res.data);

// // 退款
const refund = (params) =>
  http
    .post('/userOrder/refund', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 退款
// const refund = params =>
//   http({
//     method: 'post',
//     url: `/userOrder/refund`,
//     data: params,
//     headers: { 'Content-Type': 'application/json;charset=UTF-8' }
//   }).then(res => res.data);
// 课程订单导出Excel-以订单维度
const mainOrderExportsys = (params, cancelToken) =>
  http
    .get('/theUserIdentity/UserOrder/mainOrderExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程订单导出Excel-以商品维度
const mainProductExport = (params, cancelToken) =>
  http
    .get('/theUserIdentity/UserOrder/mainProductExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 机构结算账单列表-运营端
const getUserOrderListOrgTallyByAdmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/listOrgTally', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 机构结算账单列表-机构端
const getUserOrderListOrgTallyByOrg = (params) =>
  http
    .get('/org/settlementSheet/listOrgTally', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);

// 学校结算账单列表-运营端
const getUserOrderlistSchoolTallyByAdmin = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/listSchoolTally', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res);
// 学校结算账单列表-学校端
const getUserOrderlistSchoolTallyBySch = (params) =>
  http
    .post('/school/settlementSheet/listSchoolTally', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res);
// 查询结算账单列表-教育局端
const getUserOrderlistTallyByEdu = (params) =>
  http
    .post('/edu/settlementSheet/listTallyOrder', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);

// 机构结算账单列表 详情 -运营端
const getOrgTallyDetailByAdmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getOrgTallyDetail', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 机构结算账单列表 详情 -机构端
const getOrgTallyDetailByOrg = (params) =>
  http
    .get('/org/settlementSheet/getOrgTallyDetail', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 学校结算账单列表 详情 -运营端
const getSchTallyDetailByAdmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getSchoolTallyDetail', {
      params
    })
    .then((res) => res);
// // 上传结算账单扫描件（运营端）
const uploadStatementSheetImgByAdmin = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/uploadStatementSheetImg', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// // 上传结算账单扫描件（机构端）
const uploadStatementSheetImgByOrg = (params) =>
  http
    .post('/org/settlementSheet/uploadStatementSheetImg', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// // 查看结算账单扫描件（运营端）
const getStatementSheetImgByAdmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getStatementSheetImg', {
      params
    })
    .then((res) => res);
// // 查看结算账单扫描件（机构端）
const getStatementSheetImgByOrg = (params) =>
  http
    .get('/org/settlementSheet/getStatementSheetImg', {
      params
    })
    .then((res) => res);
// // 查看结算账单扫描件（教育局端）
const getStatementSheetImgByEdu = (params) =>
  http
    .get('/edu/settlementSheet/getStatementSheetImg', {
      params
    })
    .then((res) => res);
// 运营端确认账单(运营端)
const uploadStatementStsByAdmin = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/confirm', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// 运营端撤销账单(运营端)
const revokeStatementStsByAdmin = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/revoke', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// 学校结算账单列表 详情 - 订单明细 运营
const getProductTallyOrderDetailList = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getProductTallyOrderDetailList', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 学校结算账单列表 详情 - 订单明细  学校
const getProductTallyOrderDetailListBySch = (params) =>
  http
    .get('/school/settlementSheet/getProductTallyOrderDetailList', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 学校结算账单列表 详情 - 订单明细  机构
const getProductTallyOrderDetailListByOrg = (params) =>
  http
    .get('/org/settlementSheet/getProductTallyOrderDetailList', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 学校结算账单列表 详情 - 订单明细  教育局
const getProductTallyOrderDetailListByEdu = (params) =>
  http
    .get('/edu/settlementSheet/getProductTallyOrderDetailList', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 账单列表 详情 - 订单明细 运营 下载
const downloadProductTallyOrderDetailList = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/exportProductTallyOrderDetail', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// 账单列表 详情 - 订单明细 学校 下载
const downloadProductTallyOrderDetailListBySch = (params) =>
  http
    .get('/school/settlementSheet/exportProductTallyOrderDetail', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 账单列表 详情 - 订单明细 机构 下载
const downloadProductTallyOrderDetailListByOrg = (params) =>
  http
    .get('/org/settlementSheet/exportProductTallyOrderDetail', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// 账单列表 详情 - 订单明细 教育局 下载
const downloadProductTallyOrderDetailListByEdu = (params) =>
  http
    .get('/edu/settlementSheet/exportProductTallyOrderDetail', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 获取任务id- 订单明细 运营
const getUserOrderTaskIdByAdmin = (params) =>
  http
    .get('/userOrder/getTaskId', {
      params
    })
    .then((res) => res);

// // 学校结算账单列表 详情 -学校端
const getSchTallyDetailBySch = (params) =>
  http
    .get('/school/settlementSheet/getSchoolTallyDetail', {
      params
    })
    .then((res) => res);

// // 查询结算账单详情  -教育局结算审批单
const getEduTallyOrderDetail = (params) =>
  http
    .get('/edu/settlementSheet/getTallyOrderDetail', {
      params
    })
    .then((res) => res);
// 查询机构结算账单详情-教育局端
const getEduOrgAllyDetail = (params) =>
  http
    .get('/edu/settlementSheet/getOrgTallyDetail', {
      params,
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);

// 根据机构信息查询银行卡信息
// const getFindBankCardInfo = (params) =>
//   http
//     .get('/org/UserOrder/findBankCardInfo', {
//       params
//     })
//     .then((res) => res)
const getFindBankCardInfo = (params) =>
  http
    .get('/theUserIdentity/UserOrder/findBankCardInfo', {
      params
    })
    .then((res) => res);
// 查询审批明细
const getAuditDetail = (params) =>
  http
    .get('/edu/settlementSheet/getAuditDetail', {
      params
    })
    .then((res) => res);

// // 查询教育局流程配置
const getProcessConfiguration = (params) =>
  http
    .get('/edu/UserOrder/getProcessConfiguration', {
      params
    })
    .then((res) => res);
// // 查询教育局下的用户
const getOrgUser = (params) =>
  http
    .get('/user/getOrgUser', {
      params
    })
    .then((res) => res);
// // 添加审批节点
const addCheckAuditNode = (params) =>
  http
    .post('/edu/UserOrder/addAuditNode', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);

// // 修改审批节点
const editCheckAuditNode = (params) =>
  http
    .post('/edu/UserOrder/updateAuditNode', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res)
    .then((res) => res);
//  教育局确认账单
const updateEduUserOrderConfirm = (params) =>
  http
    .post('/edu/settlementSheet/confirm', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
//  教育局驳回账单
const updateEduUserOrderReject = (params) =>
  http
    .post('/edu/settlementSheet/reject', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// 结算账单详情导出-教育局端
const exportByTallyOrderDetail = (params) =>
  http
    .get('/edu/settlementSheet/exportTallyOrderDetail', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 获取商品id是否有考勤
const countByProductIdStudentId = (params) =>
  http
    .get('/sign/countByProductIdStudentId', { params })
    .then((res) => res.data);

// 签到记录和结算单
const listSignAndTallyByOrderId = (params) =>
  http
    .get('/theUserIdentity/courseClass/listSignAndTallyByOrderId', { params })
    .then((res) => res.data);

// /order430/userOrder/confirmRefund

// 确认退款
const confirmRefund = (params) =>
  http({
    method: 'put',
    url: `/userOrder/confirmRefund`,
    data: params,
    headers: { 'Content-Type': 'application/json' },
    errWay: '退款',
    errName: '退款单'
  }).then((res) => res.data);

// 查询退款订单详情
const refundOrderDetail = (params) =>
  http.get('/userOrder/refundOrderDetail', { params }).then((res) => res.data);

// 退款记录
const listRefundByOrderId = (params) =>
  http.get('/userOrder/listRefundByOrderId', { params }).then((res) => res.data);

// 分班课表-节次编辑
const setSignTallyStatus = (params) =>
  http
    .post('/sign/setSignTallyStatus', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 商品结算
const getRefund = (params) =>
  http
    .post('/theUserIdentity/refund/courseOrderTally', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 退款商品信息
const getRefunDetail = (params) =>
  http
    .post('/theUserIdentity/refund/detail', Qs.stringify(params))
    .then((res) => res.data);

// 运营端的 退款订单列表导出excel
const exportRefundOrderApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/UserOrder/refundOrderExport', {
      params,
      cancelToken,
      responseType: 'blob',
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'repeat' });
      }
    })
    .then((res) => res);
// const exportRefundOrderApi = params =>
//   http
//     .post('/theUserIdentity/UserOrder/refundOrderExport', params, {
//       headers: { 'Content-Type': 'application/json' }
//     })
//     .then(res => res.data);

// // 分页查询机构分账配置记录
const getDivideConfigConfigRelPage = (params) =>
  http
    .get('/theUserIdentity/divideConfig/configRelPage', {
      params
    })
    .then((res) => res);
// // 银行列表
const getFindBankList = (params) =>
  http
    .get('/theUserIdentity/divideConfig/findBankList', {
      params
    })
    .then((res) => res.data);
// 订单详情(用于订单列表页面 退款申请的展示)
const getOrderDetail = (params) =>
  http
    .post('/theUserIdentity/refund/order/detail', Qs.stringify(params))
    .then((res) => res.data);
// 课程套餐分页查询 -- 运营端
const getPackageOrderPage = (params) =>
  http
    .get('/theUserIdentity/UserOrder/packageOrderPage', { params })
    .then((res) => res.data);
// 课程套餐分页查询 -- 学校端
const getPackageOrderPageBySchool = (params) =>
  http
    .get('/school/UserOrder/packageOrderPage', { params })
    .then((res) => res.data);
// 课程套餐分页查询 -- 学校端
const getPackageOrderPageByOrg = (params) =>
  http
    .get('/org/UserOrder/packageOrderPage', { params })
    .then((res) => res.data);
// 课程套餐分页查询 -- 教育局端
const getPackageOrderPageByEdu = (params) =>
  http
    .get('/edu/UserOrder/packageOrderPage', { params })
    .then((res) => res.data);

// 课程套餐详情查询
const getPackageOrderDetail = (params) =>
  http
    .get('/theUserIdentity/UserOrder/packageOrderDetail', { params })
    .then((res) => res.data);
// 课程套餐详情查询 -- 学校端
const getPackageOrderDetailBySchool = (params) =>
  http
    .get('/school/UserOrder/packageOrderDetail', { params })
    .then((res) => res.data);
// 课程套餐详情查询 -- 机构端
const getPackageOrderDetailByOrg = (params) =>
  http
    .get('/org/UserOrder/packageOrderDetail', { params })
    .then((res) => res.data);
// 课程套餐详情查询 -- 教育局端
const getPackageOrderDetailByEdu = (params) =>
  http
    .get('/edu/UserOrder/packageOrderDetail', { params })
    .then((res) => res.data);

// 课程套餐维度导出 -- 运营端
const packageOrderPageExport = (params, cancelToken) =>
  http
    .get('/theUserIdentity/UserOrder/packageOrderPageExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程套餐维度导出 -- 学校端
const packageOrderPageExportBySch = (params, cancelToken) =>
  http
    .get('/school/UserOrder/packageOrderPageExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程套餐维度导出 -- 机构端
const packageOrderPageExportByOrg = (params, cancelToken) =>
  http
    .get('/org/UserOrder/packageOrderPageExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程套餐维度导出 -- 教育局端
const packageOrderPageExportByEdu = (params, cancelToken) =>
  http
    .get('/edu/UserOrder/packageOrderPageExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 课程订单维度导出
const packageSonOrderExport = (params, cancelToken) =>
  http
    .get('/theUserIdentity/UserOrder/packageSonOrderExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程订单维度导出  -- 学校端
const packageSonOrderExportBySch = (params, cancelToken) =>
  http
    .get('/school/UserOrder/packageSonOrderExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程订单维度导出  -- 机构端
const packageSonOrderExportByOrg = (params, cancelToken) =>
  http
    .get('/org/UserOrder/packageSonOrderExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);
// 课程订单维度导出  -- 教育局端
const packageSonOrderExportByEdu = (params, cancelToken) =>
  http
    .get('/edu/UserOrder/packageSonOrderExport', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 课程订单详情(新的)
const getCourseOrderDetailApiNew = (params) =>
  http
    .get('/theUserIdentity/UserOrder/courseOrderDetail', { params })
    .then((res) => res.data);

// 获取批量退款订单列表

const getBatchRefundListApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/page', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

const getBatchRefundCourseListApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/listDetail', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

const getBatchRefundlistSignListApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/listSign', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

const getBatchRefundCountSignApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/countSign', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 创建批量退款
const postBatchRefundApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/createBatchRefund', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 查询批量创建退款申请结果
const getCreateMsgByBatchRefundIdApi = (params) =>
  http
    .get('/theUserIdentity/batchRefund/getCreateMsgByBatchRefundId', { params })
    .then((res) => res.data);

// 查询创建批量退款创建结果统计
const getCreateMsgByBatchRefundIdStatisticsApi = (params) =>
  http
    .get('/theUserIdentity/batchRefund/getCreateMsgByBatchRefundIdStatistics', { params })
    .then((res) => res.data);

// 下载批量创建退款申请结果
const exportCreateMsgByBatchRefundIdApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/batchRefund/exportCreateMsgByBatchRefundId', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 开班失败发起退款
const startClassFailRefundApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/startClassFailRefund', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 开班失败退款校验
const startClassFailRefundCheckApi = (params) =>
  http
    .get('/theUserIdentity/batchRefund/startClassFailRefundCheck', { params })
    .then((res) => res.data);

// 审核批量退款
const confirmBatchRefundApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/confirmBatchRefund', params, {
      headers: { 'Content-Type': 'application/json' },
      errWay: '退款',
      errName: '退款单'
    })
    .then((res) => res.data);

// 查看批量退款详情
const getBatchRecordListApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/detail', Qs.stringify(params), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
    .then((res) => res.data);

// 导出退款数据
const getExportOrderApi = (params, cancelToken, onDownloadProgress) =>
  http
    .post('/theUserIdentity/batchRefund/export', params, {
      headers: { 'Content-Type': 'application/json' },
      responseType: 'blob',
      onDownloadProgress,
      cancelToken
    })
    .then((res) => res);
// const getExportOrderApi = (params, cancelToken) =>
//   http
//     .get('/theUserIdentity/batchRefund/exportOrder', {
//       params,
//       cancelToken,
//       responseType: 'blob'
//     })
//     .then((res) => res);

// 课程订单详情(新的)
const getFindBankModeList = (params) =>
  http
    .get('/theUserIdentity/divideConfig/findBankModeList', { params })
    .then((res) => res.data);
const getAcctTypes = (params) =>
  http
    .get('/theUserIdentity/divideConfig/getAcctTypes', { params })
    .then((res) => res.data);
// 新增分账规则配置
const saveDivideConfig = (params) =>
  http
    .post('/theUserIdentity/divideConfig/save', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 编辑分账规则配置
const updateDivideConfig = (params) =>
  http
    .post('/theUserIdentity/divideConfig/update', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 获取分账规则列表
const getDivideConfigList = (params) =>
  http
    .get('/theUserIdentity/divideConfig/page', { params })
    .then((res) => res.data);
// 获取分账规则详情
const getDivideConfigdDetail = (params) =>
  http
    .get('/theUserIdentity/divideConfig/detail', { params })
    .then((res) => res.data);
// 分页查询可见学校
const getDivideConfigdSchoolPage = (params) =>
  http
    .get('/theUserIdentity/divideConfig/schoolPage', { params })
    .then((res) => res.data);
// 分页查询主分账方范围
const getDivideConfigdOrgPage = (params) =>
  http
    .get('/theUserIdentity/divideConfig/orgPage', { params })
    .then((res) => res.data);
// 可见学校列表
const getDivideConfigdSchoolList = (params) =>
  http
    .get('/theUserIdentity/divideConfig/schoolList', { params })
    .then((res) => res.data);
// 设置学校可见
const saveDivideConfigRelateSch = (params) =>
  http
    .post('/theUserIdentity/divideConfig/relateSch', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 账户列表
const getDivideConfigdFindAccountList = (params) =>
  http
    .get('/theUserIdentity/divideConfig/findAccountList', {
      params
    })
    .then((res) => res.data);
// 微信线下分账机构账户列表
const getorgPageList = (params) =>
  http
    .get('/theUserIdentity/org/page', {
      params,
      paramsSerializer: function(params) {
        const keys = Object.keys(params);
        const arr = [];
        keys.forEach((item) => {
          if (Array.isArray(params[item])) {
            const url = params[item].map((_) => `${item}=${_}`).join('&');
            arr.push(url);
          } else {
            arr.push(`${item}=${params[item]}`);
          }
        });
        const result = arr.join('&');
        console.log(result);
        return `${result}`;
      }
    })
    .then((res) => res.data);

// 查询主分账方范围
const getDivideConfigdOrgList = (params) =>
  http
    .get('/theUserIdentity/divideConfig/orgList', { params })
    .then((res) => res.data);

// 关联主分账方
const saveDivideConfigRelateOrg = (params) =>
  http
    .post('/theUserIdentity/divideConfig/relateOrg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 编辑前获取短信验证码
const getDivideConfigMsg = (params) =>
  http.get('/user/sendLoginMsg', { params }).then((res) => res.data);
// 规则关联商品分页查询
const getListByDivideRuleId = (params) =>
  http
    .get('/theUserIdentity/courseClass/getListByDivideRuleId', { params })
    .then((res) => res.data);

// 机构端确认账单(机构端)
const saveOrgSettlementSheetconfirm = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/confirm', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 机构端延时结算账单(机构端)
const revokeStatementStsByOrg = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/delaySettle', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询审批明细 -- 机构端
const getAuditDetailByOrg = (params) =>
  http
    .get('/org/settlementSheet/getAuditDetail', {
      params
    })
    .then((res) => res);
// 查询审批明细 -- 运营端
const getAuditDetailByAdmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getAuditDetail', {
      params
    })
    .then((res) => res);
// 查询结算账单列表-运营端
const getUserOrderlistTallyByAdmin = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/listTallyOrder', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// // 查询结算账单详情  -教育局结算审批单  运营端
const getEduTallyOrderDetailByAdmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getTallyOrderDetail', {
      params
    })
    .then((res) => res);
// // 查询账单状态  运营端
const getSettlementSheetStatus = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getSettlementSheetStatus', {
      params
    })
    .then((res) => res.data);
// 结算账单详情导出-教育局端
const exportByTallyOrderDetailByadmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/exportTallyOrderDetail', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// // 上传结算账单扫描件（机构端）
const cancelRefundOrder = (params) =>
  http
    .post('/userOrder/cancelRefundOrder', Qs.stringify(params),
      { errWay: '退款',
        errName: '退款单' })
    .then((res) => res.data);
// 导出机构结算账单列表(运营端)
const exportAgencyBillListByadmin = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/exportAgencyBillList', {
      params,
      responseType: 'blob',
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);

// 课酬梯度-分页查询
const getCoursefeeAllotPlansApi = (params) =>
  http
    .get('/theUserIdentity/coursefeeAllotPlans/pageByCondition', {
      params
    })
    .then((res) => res.data);

// 新增课酬梯度方案
const addCoursefeeAllotPlanApi = (params) =>
  http
    .post(
      '/theUserIdentity/coursefeeAllotPlans/addCoursefeeAllotPlan',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);

// 删除课酬梯度方案
const deleteCoursefeeAllotPlanApi = (params) =>
  http
    .get('/theUserIdentity/coursefeeAllotPlans/deleteCoursefeeAllotPlan', {
      params
    })
    .then((res) => res.data);

// 课酬方案-详情查询
const getDetailByPlanIdApi = (params) =>
  http
    .get('/theUserIdentity/coursefeeAllotPlans/getDetailByPlanId', {
      params
    })
    .then((res) => res.data);

// 更新课酬方案
const editCoursefeeAllotPlanApi = (params) =>
  http
    .post(
      '/theUserIdentity/coursefeeAllotPlans/updateCoursefeeAllotPlan',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);

// 适用学校列表(分页)
const getListSchRelPlanApi = (params) =>
  http
    .get('/theUserIdentity/coursefeeAllotPlans/pageSchRelPlan', {
      params
    })
    .then((res) => res.data);

// 取消适用学校
const delListSchRelPlanApi = (params) =>
  http
    .post('/theUserIdentity/coursefeeAllotPlans/unsetOneSchRelPlan', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 设置适用学校
const setListSchRelPlanApi = (params) =>
  http
    .post('/theUserIdentity/coursefeeAllotPlans/setSchRelPlan', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 新增分账规则配置 -- 学校提供课程
const saveSchDivideConfig = (params) =>
  http
    .post('/theUserIdentity/divideConfig/saveSch', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 编辑分账规则配置 -- 学校提供课程
const updateSchDivideConfig = (params) =>
  http
    .post('/theUserIdentity/divideConfig/updateSch', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 取消批量退款
const cancelBatchRefundApi = (params) =>
  http
    .post('/theUserIdentity/batchRefund/cancelBatchRefund', params, {
      headers: { 'Content-Type': 'application/json' },
      errWay: '退款',
      errName: '退款单'
    })
    .then((res) => res.data);

// 导出退款数据
const getExportBatchRefundApi = (params, cancelToken, onDownloadProgress) =>
  http
    .post('/theUserIdentity/batchRefund/exportBatchRefund', params, {
      headers: { 'Content-Type': 'application/json' },
      responseType: 'blob',
      onDownloadProgress,
      cancelToken
    })
    .then((res) => res);
// 运营操作重置账单 (运营端)
const resetBillingOperations = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/resetBillingOperations', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 导出学校结算账单列表(运营端)
const exportAgencyBillListBySch = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/exportListSchoolTally', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 退款失败手动处理
// 运营操作重置账单 (运营端)
const refundMarkSignApi = (params) =>
  http
    .post('/theUserIdentity/UserOrder/manualProcessingRefund', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
const getOrderDataStatistics = (params) =>
  http
    .get('/theUserIdentity/UserOrder/orderDataStatistics', { params })
    .then((res) => res.data);
// 教育局账单数据统计 (教育局端)
const getEduBillStatisticsForEdu = (params) =>
  http
    .post('/edu/settlementSheet/eduBillStatistics', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 根据教育局查询学年学期
const getYearTermList = (params) =>
  http.get('/commons/getYearTermList', { params }).then((res) => res.data);

const getRefundOrderDataStatistics = (params) =>
  http
    .get('/theUserIdentity/UserOrder/countRefund', { params })
    .then((res) => res.data);

// 导入教师考勤确认单
const importSettlementSheetSchItem = (params) =>
  http.post(
    '/theUserIdentity/settlementSheetSch/importSettlementSheetSchItem',
    params,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
// 生成学校工资单
const createMonthSheet = (params) =>
  http.post('/theUserIdentity/settlementSheetSch/createMonthSheet', params, {
    headers: { 'content-Type': 'application/json' }
  });

// 结算单管理-订单明细统计
const getToSettleBillDetails = (params) =>
  http
    .post('/theUserIdentity/settlementSheet/toSettleBillDetails', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 获取开通工资发放的学校列表
const findSchList = (params) =>
  http
    .get('/theUserIdentity/settlementSheetSch/findSchList', { params })
    .then((res) => res.data);

// 分页查询账单机构列表

const getConfigOrgList = (params) =>
  http
    .post(`/theUserIdentity/settlementSheet/getConfigOrgList`, params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 获取关联的单位
const getWxOrgList = (params) =>
  http.get('/theUserIdentity/common/org', { params }).then((res) => res.data);

// 获取操作日志
const getOperateRecPage = (params) =>
  http
    .get('/theUserIdentity/operateRec/operateRecPage', {
      params
    })
    .then((res) => res.data);
// 学校确认单下载接口日志
const schoolSettlementSheetDownRec = (params) =>
  http
    .post('/common/schoolSettlementSheetDownRec', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 确认微信线下账单

const setWechatConfirm = (params) =>
  http
    .post(`/theUserIdentity/settlementSheet/wechat/confirm`, params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 批量运营端确认账单
const batchConfirmSettleSheet = (params) =>
  http
    .post(`/theUserIdentity/settlementSheet/batchConfirmSettleSheet`, params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 机构结算单下载接口日志
const orgSettlementSheetDownRec = (params) =>
  http
    .post('/common/orgSettlementSheetDownRec', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询待审批的退款处理单 (运营端)
const refundOrderListBySettlementId = (params) =>
  http
    .get('/theUserIdentity/UserOrder/refundOrderListBySettlementId', {
      params
    })
    .then((res) => res.data);

// 学生请假可退款批量退款审批
const leaveCanRefundCheck = (params) =>
  http
    .post('/theUserIdentity/UserOrder/leaveCanRefundCheck', params, {
      headers: { 'content-Type': 'application/json' },
      errWay: '请假可退款',
      errName: '请假单'
    })
    .then((res) => res.data);
// 新增优惠券
const addCoupons = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/addCoupons', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 优惠券分页列表
const getCouponsList = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/pageOfferCoupons', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
//
const getCouponsDetails = (params) =>
  http
    .get('/theUserIdentity/offerCoupon/getCoupons', {
      params
    })
    .then((res) => res.data);
// 编辑优惠券
const editCoupons = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/editCoupons', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 作废优惠券
const invalidCoupon = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/invalidCoupon', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 优惠券明细分页列表
const getCouponsUsersList = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/pageCouponsUsersDetail', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询优惠券指定的课程商品
const getCouponsCourseList = (params) =>
  http
    .get('/theUserIdentity/offerCoupon/couponsCourseGoodsShallApply', {
      params
    })
    .then((res) => res.data);

// 优惠券发放学生范围查询
const getCouponsIssuedRangeQueries = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/couponsIssuedRangeQueries', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 禁用用户优惠券
const disableUserCoupons = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/disableUserCoupons', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 导出-优惠券列表
const exportCouponsList = (params) =>
  http
    .get('/theUserIdentity/offerCoupon/exportCouponsList', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 导出-优惠券明细列表
const exportCouponsUsersDetail = (params) =>
  http
    .get('/theUserIdentity/offerCoupon/exportCouponsUsersDetail', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 发放优惠券验证短信
const sendOfferCouponMsg = (params) =>
  http
    .get('/theUserIdentity/offerCoupon/sendMsg', {
      params
    })
    .then((res) => res.data);
// 发放用户优惠券
const batchIssueCoupons = (params) =>
  http
    .post('/theUserIdentity/offerCoupon/batchIssueCoupons', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询账单银行Id
const getBankIdOrgByAreaCode = (params) =>
  http
    .get('/theUserIdentity/settlementSheet/getBankIdOrgByAreaCode', {
      params
    })
    .then((res) => res.data);
// 查询材料费可退款节次费用
const getMaterialAvailableRefundAmountByTimes = (params) =>
  http
    .get('/userOrder/getMaterialAvailableRefundAmountByTimes', { params })
    .then((res) => res.data);
// 材料费订单列表
const getMaterialOrderPage = (params) =>
  http
    .post('/theUserIdentity/UserOrder/materialOrderPage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 材料费订单数据统计
const getMaterialOrderDataStatistics = (params) =>
  http
    .post('/theUserIdentity/UserOrder/materialOrderDataStatistics', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 材料费订单列表导出
const materialOrderExport = (params) =>
  http
    .get('/theUserIdentity/UserOrder/materialOrderExport', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 查询可结算材料费分页列表
const getSettleMaterials = (params) =>
  http
    .post('/theUserIdentity/userOrdOffSettle/canSettleMaterials', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 查询材料费可结算节次费用
const batchMaterialWithholdCompute = (params) =>
  http
    .post(
      '/theUserIdentity/settlementSheet/batchMaterialWithholdCompute',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 后台导入待付款订单一键催交
const callPendingPaymentOrders = (params) =>
  http
    .get('/userOrder/callPendingPaymentOrders', {
      params
    })
    .then((res) => res);
// 课程订单导入模版
const getOrderImportTemplate = (params) =>
  http
    .get('/theUserIdentity/UserOrder/downloadOrderImportTemplate', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);

// 订单导入解析
const parsingImportOrder = (params) =>
  http
    .post(`/theUserIdentity/UserOrder/parsingImportOrder`, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then((res) => res.data);

// 确定提交订单导入
const commitImportOrder = (params) =>
  http
    .post('/theUserIdentity/UserOrder/commitImportOrder', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 查询子任务进度-运营端
const getQrySubTaskProgress = (params, cancelToken) =>
  http
    .post('/theUserIdentity/batchProcData/qrySubTaskProgress', params, {
      headers: { 'Content-Type': 'application/json' },
      cancelToken
    })
    .then((res) => res.data);
// 关闭订单 (运营端)
const updateCloseOrder = (params) =>
  http
    .get('/theUserIdentity/UserOrder/closeOrder', {
      params
    })
    .then((res) => res.data);

// 分页查询主分账方范围（入账类型为平安/工行）
const getDivideConfigOrgPage = (params) =>
  http
    .get('/theUserIdentity/divideConfig/orgPage', { params })
    .then((res) => res.data);
// 删除关联分账规则
const deleteRelById = (params) =>
  http
    .get('/theUserIdentity/divideConfig/deleteRelById', { params })
    .then((res) => res.data);

// 编辑分账规则关联的主分账信息
const updateMainRelOrg = (params) =>
  http
    .post('/theUserIdentity/divideConfig/updateMainRelOrg', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 规则关联商品分页查询
const getCourseClassMaterialPage = (params) =>
  http
    .get('/theUserIdentity/courseClassMaterial/getCourseClassMaterialPage', {
      params
    })
    .then((res) => res.data);
// 配置结算单审批流程
const configureSettlementApprovalProcess = (params) =>
  http
    .get('/edu/sysStaticDatas/configureSettlementApprovalProcess', {
      params
    })
    .then((res) => res.data);
// 结算账单列表-新
const getSubSheetListPage = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/subSheetListPage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 导出机构结算账单列表-新
const exportSubSheetList = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/exportSubSheetList', {
      params,
      responseType: 'blob',
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 学校确认单列表-新
const getSchoolSheetListPage = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/schoolSheetListPage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 导出学校确认单列表-新
const exportSchoolSheetList = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/exportSchoolSheetList', {
      params,
      responseType: 'blob',
      paramsSerializer: (params) => {
        return Qs.stringify(params, { arrayFormat: 'indices' });
      }
    })
    .then((res) => res);
// 结算账单详情 新
const getSubOrgSheetDetailsList = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/subOrgSheetDetailsList', {
      params
    })
    .then((res) => res.data);

// 机构分帐单列表-新
const getSchSubSheetList = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/subSheetList', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 分账单订单明细列表 新
const getBillOrderLedgerDetails = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/billOrderLedgerDetails', {
      params
    })
    .then((res) => res.data);
// 批量_教务审核帐单-新
const batchAcademicAffairsApproval = (params) =>
  http
    .post(
      '/theUserIdentity/mergedDivideSheet/batchAcademicAffairsApproval',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);

// 教务撤销审批帐单-新
const batchAcademicAffairsRevocationApprovalApi = (params) =>
  http
    .post(
      '/theUserIdentity/mergedDivideSheet/batchAcademicAffairsRevocationApproval',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);

// 运营审批分帐单(运营端) 新
const uploadOperationsApproval = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/operationsApproval', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// 分账单订单明细统计 新
const getBillOrderDetailsStatistics = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/billOrderDetailsStatistics', {
      params
    })
    .then((res) => res.data);
// 运营撤销审批帐单(运营端) 新
const uploadOperationRevocationApproval = (params) =>
  http
    .post(
      '/theUserIdentity/mergedDivideSheet/operationRevocationApproval',
      params,
      {
        headers: { 'content-Type': 'application/json' }
      }
    )
    .then((res) => res);
//  提供方审批帐单  - 新
const orgUpdateProviderApproval = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/providerApproval', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 发送收款方、提供方审批验证短信 新
const sendRecipientApprovalVerificationSms = (params) =>
  http
    .get(
      '/theUserIdentity/mergedDivideSheet/sendRecipientApprovalVerificationSms',
      {
        params
      }
    )
    .then((res) => res.data);

//  收款方审批帐单  - 新
const orgUpdatePayeeApproval = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/payeeApproval', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// // 上传结算账单扫描件（运营端） 新
const uploadBillReviewForm = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/uploadBillReviewForm', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);
// // 查看结算账单扫描件（运营端） - 新
const getBillReviewForm = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/getBillReviewForm', {
      params
    })
    .then((res) => res.data);
// 批量运营端确认账单 - 新
const batchOperationsApproval = (params) =>
  http
    .post(
      `/theUserIdentity/mergedDivideSheet/batchOperationsApproval`,
      params,
      {
        headers: { 'content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 教育局预审批分帐单 - 新
const eduPreApproval = (params) =>
  http
    .post(`/theUserIdentity/mergedDivideSheet/eduPreApproval`, params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 教育局审批分帐单 - 新
const eduApproval = (params) =>
  http
    .post(`/theUserIdentity/mergedDivideSheet/eduApproval`, params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);
// // 查询分账单审批明细 - 新
const getQueryAndApproveSplitBills = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/queryAndApproveSplitBills', {
      params
    })
    .then((res) => res.data);
// 导出_分账单教育局审批单 - 新
const exportEduSubSheet = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/exportEduSubSheet', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// 导出_分账单订单明细列表 - 新
const exportBillOrderLedgerDetails = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/exportBillOrderLedgerDetails', {
      params,
      responseType: 'blob'
    })
    .then((res) => res);
// // 查询分帐单关联的学校 - 新
const getQuerySheetAssociatedSchool = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/querySheetAssociatedSchool', {
      params
    })
    .then((res) => res.data);
// // 查询分帐单关联的课程提供方 - 新
const getQuerySheetAssociatedOrg = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/querySheetAssociatedOrg', {
      params
    })
    .then((res) => res.data);
// // 查询分帐单关联的收款方 - 新
const getQuerySheetAssociatedStatementOrg = (params) =>
  http
    .get(
      '/theUserIdentity/mergedDivideSheet/querySheetAssociatedStatementOrg',
      {
        params
      }
    )
    .then((res) => res.data);

// 异步创建课程订单
const createCourseOrderAsyncApi = (params) =>
  http
    .post('/theUserIdentity/UserOrder/createCourseOrderAsync', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// // 查询可催缴订单 - 新
const getQueryCallableOrders = (params) =>
  http
    .post(`/userOrder/queryCallableOrders`, params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// // 查询可催缴订单 - 新
const bulkCallPendingPaymentOrders = (params) =>
  http
    .post(`/userOrder/bulkCallPendingPaymentOrders`, params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

//  修改退款单节次
const revampRefundSignApi = (params) =>
  http
    .post('/userOrder/revampRefundSign', params, {
      headers: { 'content-Type': 'application/json' },
      errWay: '退款',
      errName: '退款单'
    })
    .then((res) => res.data);

// 机构分帐单列表
const getSubSheetListApi = (params) =>
  http
    .post('/theUserIdentity/mergedDivideSheet/subSheetList', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 查询分账单扫描件(服务学校模式)
const getListByObjIdAndTypesApi = (params) =>
  http
    .post('/theUserIdentity/settlementSheetFiles/listByObjIdAndTypes', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 上传分账单扫描件(服务学校模式)
const uploadBillReviewFormApi = (params) =>
  http
    .post('/theUserIdentity/settlementSheetFiles/uploadBillReviewForm', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res);

// 多分账单订单明细统计
const getBillOrderDetailsStatisticsTotalApi = (params) =>
  http
    .get('/theUserIdentity/mergedDivideSheet/billOrderDetailsStatisticsTotal', {
      params
    })
    .then((res) => res.data);

// 第三方周期结算单-分页查询
const querythirdPlatSettleSheetApi = (params) =>
  http
    .get('/theUserIdentity/thirdPlatSettleSheet/queryPageByCondition', {
      params
    })
    .then((res) => res.data);

// 课程订单导出Excel-以商品维度
const exportthirdPlatSettleSheetApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/thirdPlatSettleSheet/exportByCondition', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 根据sheetId获取收费确认单详情
const getDetailBySheetIdApi = (params) =>
  http
    .get('/theUserIdentity/thirdPlatSettleSheet/getDetailBySheetId', {
      params
    })
    .then((res) => res.data);

// 根据sheetId获取收费确认单详情
const generateThirdPlatSettleSheetDetailPdfFileApi = (params) =>
  http
    .get('/theUserIdentity/thirdPlatSettleSheet/generateThirdPlatSettleSheetDetailPdfFile', {
      params
    })
    .then((res) => res.data);

// 第三方周期结算单-订单结算明细分页列表
const pageOrderSettlementDetailApi = (params) =>
  http
    .post('/theUserIdentity/thirdPlatSettleSheet/pageOrderSettlementDetail', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 第三方周期结算单-导出订单结算明细列表
const exportOrderSettlementDetailApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/thirdPlatSettleSheet/exportOrderSettlementDetail', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 结算单关联单位-分页查询
const getSettleSheetRelOrgPageApi = (params) =>
  http
    .get('/theUserIdentity/thirdPlatSettleSheet/settleSheetRelOrgPage', {
      params
    })
    .then((res) => res.data);

// 请款单分页列表
const getSheetListPageForRefundApi = (params) =>
  http
    .post('/theUserIdentity/requestRefundSheet/getSheetListPage', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 查询请款单退款订单
const getRequestRefundOrderPageApi = (params) =>
  http
    .post('/theUserIdentity/UserOrder/requestRefundOrderPage', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 查询请款单请假可退款订单
const getRequestLeaveOrderPageApi = (params) =>
  http
    .post('/theUserIdentity/classroomStudentLeave/requestLeaveOrderPage', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 导出请款单

const exportSheetListApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/requestRefundSheet/exportSheetList', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 查询请款单详情
const getSheetDetailApi = (params) =>
  http
    .get('/theUserIdentity/requestRefundSheet/getSheetDetail', {
      params
    })
    .then((res) => res.data);

// 生成请款单面单pdf文件
const getSheetDetailPdfFileApi = (params) =>
  http
    .get('/theUserIdentity/requestRefundSheet/sheetDetailPdfFile', {
      params
    })
    .then((res) => res.data);

// 查询请款单订单明细
const getRequestLeaveRefundOrderPageApi = (params) =>
  http
    .post('/theUserIdentity/UserOrder/requestLeaveRefundOrderPage', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 导出退款订单和请假可退款明细
const exportRequestLeaveRefundOrdersApi = (params, cancelToken) =>
  http
    .get('/theUserIdentity/UserOrder/exportRequestLeaveRefundOrders', {
      params,
      cancelToken,
      responseType: 'blob'
    })
    .then((res) => res);

// 请款单退款订单统计
const getRequestSheetListStatisticsApi = (params) =>
  http
    .post('/theUserIdentity/UserOrder/requestRefundOrderStatistics', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 查询请款单请假可退款订单统计
const getRequestLeaveOrderStatisticseApi = (params) =>
  http
    .post('/theUserIdentity/classroomStudentLeave/requestLeaveOrderStatistics', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 创建请款单
const addRequestRefundSheetApi = (params) =>
  http
    .post('/theUserIdentity/requestRefundSheet/add', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 请款单确认
const confirmRequestRefundSheetApi = (params) =>
  http
    .post('/theUserIdentity/requestRefundSheet/confirm', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 请款单撤回
const revokeRequestRefundSheetApi = (params) =>
  http
    .post('/theUserIdentity/requestRefundSheet/revoke', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除请款单
const deleteRequestRefundSheetApi = (params) =>
  http
    .post('/theUserIdentity/requestRefundSheet/delete', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除请款单
const removeItemsRefundSheetApi = (params) =>
  http
    .post('/theUserIdentity/requestRefundSheet/removeItems', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 新增退款单/请假单
const appendItemsRefundSheetApi = (params) =>
  http
    .post('/theUserIdentity/requestRefundSheet/appendItems', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 新增收费确认单
const addSettleSheetFormApi = (params) =>
  http
    .post('/theUserIdentity/thirdPlatSettleSheet/add', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 删除第三方周期结算单
const deleteSettleSheetFormApi = (params) =>
  http
    .post('/theUserIdentity/thirdPlatSettleSheet/delete', params, {
      headers: { 'content-Type': 'application/json' }
    })
    .then((res) => res.data);

export default {
  startClassFailRefundCheckApi,
  startClassFailRefundApi,
  leaveCanRefundCheck,
  getCurrentSemesterStatistics,
  getRevenueDataStatistic,
  getToRemind,
  getRefunDetail,
  getRefund,
  setSignTallyStatus,
  listRefundByOrderId,
  refundOrderDetail,
  getSchoolsList,
  getBranchList,
  getlistTerms,
  getGradeAndClass,
  getOrderList,
  getCourseOrderDetail,
  orderRefund,
  getOrgSchoolsNew,
  updatePreOrderPayTime,
  getgoodSchoolList,
  getOrgSchoolListNew,
  getOperateOrderList,
  opeRefundOrder,
  getRefundOrderListApi,
  getRefundDtl,
  refund,
  mainOrderExportsys,
  mainProductExport,
  getUserOrderListOrgTallyByAdmin,
  getUserOrderListOrgTallyByOrg,
  getUserOrderlistSchoolTallyByAdmin,
  getUserOrderlistSchoolTallyBySch,
  getOrgTallyDetailByAdmin,
  getSchTallyDetailByAdmin,
  uploadStatementSheetImgByAdmin,
  getStatementSheetImgByAdmin,
  getStatementSheetImgByOrg,
  getStatementSheetImgByEdu,
  uploadStatementStsByAdmin,
  revokeStatementStsByAdmin,
  uploadStatementSheetImgByOrg,
  getProductTallyOrderDetailList,
  getProductTallyOrderDetailListBySch,
  getProductTallyOrderDetailListByOrg,
  getProductTallyOrderDetailListByEdu,
  downloadProductTallyOrderDetailList,
  downloadProductTallyOrderDetailListBySch,
  downloadProductTallyOrderDetailListByOrg,
  downloadProductTallyOrderDetailListByEdu,
  getUserOrderTaskIdByAdmin,
  getOrgTallyDetailByOrg,
  getSchTallyDetailBySch,
  getEduTallyOrderDetail,
  getEduOrgAllyDetail,
  getProcessConfiguration,
  getOrgUser,
  addCheckAuditNode,
  editCheckAuditNode,
  updateEduUserOrderConfirm,
  updateEduUserOrderReject,
  exportByTallyOrderDetail,
  getFindBankCardInfo,
  getAuditDetail,
  getUserOrderlistTallyByEdu,
  countByProductIdStudentId,
  listSignAndTallyByOrderId,
  confirmRefund,
  exportRefundOrderApi,
  getDivideConfigConfigRelPage,
  getFindBankList,
  getOrderDetail,
  getPackageOrderPage,
  getPackageOrderDetail,
  getPackageOrderDetailBySchool,
  getPackageOrderDetailByOrg,
  packageOrderPageExport,
  packageOrderPageExportBySch,
  packageOrderPageExportByOrg,
  packageSonOrderExport,
  packageSonOrderExportBySch,
  packageSonOrderExportByOrg,
  packageSonOrderExportByEdu,
  packageOrderPageExportByEdu,
  getPackageOrderPageBySchool,
  getPackageOrderPageByOrg,
  getPackageOrderPageByEdu,
  getPackageOrderDetailByEdu,
  getCourseOrderDetailApiNew,

  getBatchRefundListApi,
  getBatchRefundCourseListApi,
  getBatchRefundlistSignListApi,
  getBatchRefundCountSignApi,
  postBatchRefundApi,
  getCreateMsgByBatchRefundIdApi,
  getCreateMsgByBatchRefundIdStatisticsApi,
  exportCreateMsgByBatchRefundIdApi,
  confirmBatchRefundApi,
  getBatchRecordListApi,
  getExportOrderApi,
  getFindBankModeList,
  saveDivideConfig,
  updateDivideConfig,
  getDivideConfigList,
  getDivideConfigdDetail,
  getDivideConfigdSchoolPage,
  getDivideConfigdOrgPage,
  getDivideConfigdSchoolList,
  saveDivideConfigRelateSch,
  getDivideConfigdFindAccountList,
  getDivideConfigdOrgList,
  saveDivideConfigRelateOrg,
  getDataSearchYearList,
  getDivideConfigMsg,
  getListByDivideRuleId,
  saveOrgSettlementSheetconfirm,
  revokeStatementStsByOrg,
  getAuditDetailByOrg,
  getAuditDetailByAdmin,
  getUserOrderlistTallyByAdmin,
  getEduTallyOrderDetailByAdmin,
  getSettlementSheetStatus,
  exportByTallyOrderDetailByadmin,
  cancelRefundOrder,
  exportAgencyBillListByadmin,
  getCoursefeeAllotPlansApi,
  addCoursefeeAllotPlanApi,
  deleteCoursefeeAllotPlanApi,
  getDetailByPlanIdApi,
  editCoursefeeAllotPlanApi,
  getListSchRelPlanApi,
  delListSchRelPlanApi,
  setListSchRelPlanApi,
  cancelBatchRefundApi,
  getExportBatchRefundApi,
  saveSchDivideConfig,
  resetBillingOperations,
  refundMarkSignApi,
  updateSchDivideConfig,
  getOrderDataStatistics,
  getEduBillStatisticsForEdu,
  getYearTermList,
  importSettlementSheetSchItem,
  createMonthSheet,
  getRefundOrderDataStatistics,
  getToSettleBillDetails,
  getConfigOrgList,
  findSchList,
  getAcctTypes,
  getorgPageList,
  getWxOrgList,
  getOperateRecPage,
  schoolSettlementSheetDownRec,
  setWechatConfirm,
  batchConfirmSettleSheet,
  orgSettlementSheetDownRec,
  refundOrderListBySettlementId,
  exportAgencyBillListBySch,
  addCoupons,
  getCouponsList,
  getCouponsDetails,
  editCoupons,
  invalidCoupon,
  getCouponsUsersList,
  getCouponsCourseList,
  getCouponsIssuedRangeQueries,
  disableUserCoupons,
  exportCouponsList,
  exportCouponsUsersDetail,
  sendOfferCouponMsg,
  batchIssueCoupons,
  getBankIdOrgByAreaCode,
  getMaterialAvailableRefundAmountByTimes,
  getMaterialOrderPage,
  getMaterialOrderDataStatistics,
  materialOrderExport,
  getSettleMaterials,
  batchMaterialWithholdCompute,
  callPendingPaymentOrders,
  getOrderImportTemplate,
  parsingImportOrder,
  commitImportOrder,
  getQrySubTaskProgress,
  updateCloseOrder,
  getDivideConfigOrgPage,
  deleteRelById,
  updateMainRelOrg,
  getCourseClassMaterialPage,
  configureSettlementApprovalProcess,
  getSubSheetListPage,
  exportSubSheetList,
  getSchoolSheetListPage,
  exportSchoolSheetList,
  getSubOrgSheetDetailsList,
  getSchSubSheetList,
  getBillOrderLedgerDetails,
  batchAcademicAffairsApproval,
  batchAcademicAffairsRevocationApprovalApi,
  uploadOperationsApproval,
  getBillOrderDetailsStatistics,
  uploadOperationRevocationApproval,
  orgUpdateProviderApproval,
  sendRecipientApprovalVerificationSms,
  orgUpdatePayeeApproval,
  uploadBillReviewForm,
  getBillReviewForm,
  batchOperationsApproval,
  eduApproval,
  eduPreApproval,
  getQueryAndApproveSplitBills,
  exportEduSubSheet,
  exportBillOrderLedgerDetails,
  getQuerySheetAssociatedStatementOrg,
  getQuerySheetAssociatedOrg,
  getQuerySheetAssociatedSchool,
  getQueryCallableOrders,
  bulkCallPendingPaymentOrders,
  createCourseOrderAsyncApi,
  revampRefundSignApi,
  getSubSheetListApi,
  getListByObjIdAndTypesApi,
  uploadBillReviewFormApi,
  getBillOrderDetailsStatisticsTotalApi,
  querythirdPlatSettleSheetApi,
  exportthirdPlatSettleSheetApi,
  getDetailBySheetIdApi,
  generateThirdPlatSettleSheetDetailPdfFileApi,
  pageOrderSettlementDetailApi,
  exportOrderSettlementDetailApi,
  getSettleSheetRelOrgPageApi,
  getSheetListPageForRefundApi,
  getRequestRefundOrderPageApi,
  getRequestLeaveOrderPageApi,
  exportSheetListApi,
  getSheetDetailApi,
  getSheetDetailPdfFileApi,
  getRequestLeaveRefundOrderPageApi,
  exportRequestLeaveRefundOrdersApi,
  getRequestSheetListStatisticsApi,
  getRequestLeaveOrderStatisticseApi,
  addRequestRefundSheetApi,
  confirmRequestRefundSheetApi,
  revokeRequestRefundSheetApi,
  deleteRequestRefundSheetApi,
  removeItemsRefundSheetApi,
  appendItemsRefundSheetApi,
  addSettleSheetFormApi,
  deleteSettleSheetFormApi
};
